import { render, staticRenderFns } from "./ProductPlatform.vue?vue&type=template&id=3ec339c7&scoped=true&"
import script from "./ProductPlatform.vue?vue&type=script&lang=js&"
export * from "./ProductPlatform.vue?vue&type=script&lang=js&"
import style0 from "./ProductPlatform.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ProductPlatform.vue?vue&type=style&index=1&id=3ec339c7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec339c7",
  null
  
)

export default component.exports